<template>
    <div class="flats-crm-card-map-container">
        <!-- КАРТА КОМПЛЕКСА -->
        <!-- {{cardData}} -->
        <div class="map" id='YmapComplexCrmCard'></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-card-map',
        props: ['cardData'],
        components: {
        },
        data () {
            return {
                zoom: 14,
                offset: 150,
                ballonOffset: [100, 400],
                animate: true,
                activeBallon: null,
            }
        },
        computed: mapGetters({
            // pageSetup: 'loadSalesMapPage',
            // currentCity: 'loadCurrentCity',
            // currentCityArr: 'loadCurrentCityArr',
            // mapCoords: 'loadMapCoords',
            // marMarkerPos: 'loadMapMarkersPos',
            // projectItemsMap: 'loadProjectItemsMap',
            // projectItemsDefault: 'loadProjectItemsDefault',
            // projectItemsFilter: 'loadProjectItemsFilter',
        }),
        methods: {
            mapInit() {
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    if (this.cardData != null) {
                        var _self = this;
                        
                        var complexData = _self.cardData,
                            lat = this.cardData.map_lat,
                            lng = this.cardData.map_lng;

                        // var location = this.currentCityArr;
                        var marker = 'https://sales.bazis.kz/cms/media/2019/11/pin_static.svg';
                        var marker_active = 'https://sales.bazis.kz/cms/media/2019/11/pin_active.svg';
                        var zoom = this.zoom;
                        var offset = this.offset;
                        // var i;
                        // var pin;
                        var Ymap;
                        var myPlacemark;
                        // var links = $('.sales-filter-default a');
                        ymaps.ready().then(function() {

                            Ymap = new ymaps.Map('YmapComplexCrmCard', {
                                center: [lng, lat],
                                zoom: zoom,
                                controls: ['fullscreenControl'],
                                behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                            },{suppressMapOpenBlock: true, minZoom: 11, maxZoom: 18});
                            Ymap.controls.add('zoomControl', {position: {right: '10px', top: '180px'}});

                            myPlacemark = new ymaps.Placemark([lng,lat], {
                                hintContent: '<div class="yandex-tooltip"><p>' + complexData.project_name.slug.toUpperCase() + '</p></div>',
                                balloonLayout: "default#imageWithContent",
                                balloonContentBody: 
                                    '<div class="ballon-main-container">' +
                                        '<a class="link-to-page btn-link-more-href" href="' + 'sales/' + complexData.project_name.slug + '" data-index="' + 1 + '" data-init="' + complexData.project_site_type + '" data-name="'+ complexData.project_name.slug +'">' +
                                            '<div class="item-img">' +
                                                '<img  class="baloon-pic" src="' + complexData.project_img + '"/>' +
                                            '</div>' + 
                                            '<div class="item-desc">' +
                                                '<div class="item-logo">' +
                                                    '<img src="' + complexData.logo_color + '"/>' +
                                                '</div>' +
                                                '<div class="adres">' +  complexData.project_adres  +
                                                '</div>' +
                                            '</div>' +
                                        '</a>' +
                                    '</div>',
                            }, {
                                openEmptyBalloon: false,
                                hideIconOnBalloonOpen: false,
                                balloonOffset: _self.ballonOffset,
                                iconLayout: 'default#image',
                                iconImageHref: marker,
                                iconImageSize: [70, 90],
                                iconImageOffset: [-30, -100]
                            });
                            Ymap.geoObjects.add(myPlacemark);
                            Ymap.setCenter([lng, lat]);

                            var watchEventMarkers = function() {
                                var hover = null;
                                myPlacemark.events
                                .add('balloonopen', function(e) {
                                    hover = 1;
                                    e.get('target').options.set('iconImageHref', marker_active);
                                    $('.btn-link-more-href').on('click', function(elem) {
                                        // console.log('click')
                                        elem.preventDefault();
                                        var dataIndex = $(this).data('index'),
                                            dataInit = $(this).data('init'),
                                            dataName = $(this).data('name');

                                        if (dataInit != 'from') {
                                            window.open(complexData.project_site_in.link, '_blank');
                                        } else {
                                            return false;
                                        }
                                    });
                                    $('.ymaps-2-1-79-balloon-pane').addClass('animate');
                                })
                                .add('balloonclose', function(e) {
                                    hover = null;
                                    e.get('target').options.set('iconImageHref', marker);
                                    $('.ymaps-2-1-79-balloon-pane').removeClass('animate');
                                })
                                .add('mouseenter', function(e) {
                                    e.get('target').options.set('iconImageHref', marker_active);
                                })
                                .add('mouseleave', function(e) {
                                    if (hover == null) {
                                        e.get('target').options.set('iconImageHref', marker);
                                    }
                                    e.originalEvent.map.hint.close();
                                });
                            };


                            var UpdateControls = function() {
                                if ($(window).width() <= 1024) {
                                    Ymap.behaviors.disable('drag');
                                }
                                // if ($(window).width() <= 767) {
                                //     _self.zoom = 12;
                                //     _self.offset = 50;
                                //     _self.ballonOffset = [100, 240];
                                // }
                            };

                            watchEventMarkers();


                            // initMap();
                            // UpdateControls();
                            // buildPinsOnMap();
                            // clicker();
                            // updateMap();
                            
                        });
                    }
                });
            },
            checkMobile() {
                var _self = this;
                if ($(window).width() <= 767) {
                    _self.zoom = 12;
                    _self.offset = 50;
                    _self.ballonOffset = [100, 240];
                }
            }
            // closeLoopCardImg() {
            //     this.$store.commit('setVisibleCardImgWindow', false);
            //     this.$store.commit('setCardImgData', null);
            //     window.body.removeClass('overflowTrue');
            //     document.getElementById('header').classList.remove('notvisible');
            //     document.getElementById('footer').classList.remove('notvisible');
            //     if (this.banerTopCoockieVisible == true) {
            //         document.getElementById('banerTopHorizont').classList.remove('notvisible');
            //     }
            // },
            // setGridView(param) { 
			// 	this.$store.commit('gridViewFlatsCardSet', param);
            // },
        },
        beforeCreate() {
        },
        created () {
            this.mapInit();
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card-map.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-card-map-respond.scss';

    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>